import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setDeleteLoading } from "../menu/menuSlice";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../utils/utilFunctions";

export const getWarehouse = createAsyncThunk("app/getWarehouse", async (id) => {
  const res = await axios.get(`/api/loc/warehouse?id=${id}`);
  return res.data;
});

export const getWarehouses = createAsyncThunk(
  "app/getWarehouses",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(
      `/api/loc/warehouse/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const addWarehouse = createAsyncThunk(
  "app/addWarehouse",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.post("api/loc/warehouse", body, config);
      successAlertHandle("Depot added successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateWarehouse = createAsyncThunk(
  "app/updateWarehouse",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.put("api/loc/warehouse", body, config);
      successAlertHandle("Depot updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteWarehouse = createAsyncThunk(
  "app/deleteWarehouse",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/loc/warehouse?id=${id}`);
      successAlertHandle("Depot deleted successfully!", dispatch);
      dispatch(setDeleteLoading(false));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);
